import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { getImagePath } from '../../utils/imagePath';

const BalletGymnastics = () => {
  const [activeImage, setActiveImage] = useState(0);

  const sectionData = {
    name: 'Ballet and Gymnastics',
    category: 'Dance & Gymnastics',
    description: 'Graceful ballet and dynamic gymnastics for children and adults.',
    longDescription: 'Our Ballet and Gymnastics program offers a perfect blend of artistry and athleticism. From classical ballet to modern gymnastics, students develop strength, flexibility, and grace in a nurturing environment. With experienced instructors and age-appropriate classes, we help every student reach their full potential.',
    images: [
      getImagePath('images/bars/ballet-gymnastics.jpg'),
      getImagePath('images/bars/ballet-gymnastics.jpg'),
      getImagePath('images/bars/ballet-gymnastics.jpg')
    ],
    icon: 'fa-child',
    members: '28+ active members',
    coach: 'Madame Elena Petrova & Coach Michael Ade',
    schedule: 'Mon, Wed: 4pm | Sat: 9am',
    level: 'Kids & Adults',
    features: [
      'Ballet Classes',
      'Gymnastics Training',
      'Performance Opportunities',
      'Competition Team',
      'Adult Classes',
      'Parent & Child Classes',
      'Summer Camps',
      'Recitals'
    ],
    facilities: ['Dance Studio', 'Gymnastics Equipment', 'Changing Rooms', 'Waiting Area'],
    contact: {
      phone: '+234 905 584 6379',
      email: 'dance@nlngraclub.com',
      extension: '203'
    },
    classes: ['Creative Movement', 'Ballet', 'Gymnastics', 'Contemporary', 'Adult Ballet'],
    performances: ['Annual Recital', 'Holiday Show', 'Competition Events']
  };

  return (
    <div className="section-detail-page">
      {/* Hero Section */}
      <section className="section-detail-hero">
        <div className="hero-background">
          <img src={sectionData.images[0]} alt={sectionData.name} />
          <div className="hero-overlay"></div>
        </div>
        <div className="container">
          <motion.div 
            className="hero-content"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <Link to="/sections" className="back-link">
              <i className="fas fa-arrow-left"></i> Back to Sections
            </Link>
            <span className="section-category">{sectionData.category}</span>
            <h1 className="section-title">{sectionData.name}</h1>
            <p className="section-subtitle">{sectionData.description}</p>
          </motion.div>
        </div>
      </section>

      {/* Section Content */}
      <section className="section-content-section">
        <div className="container">
          <div className="section-grid">
            {/* Left Column - Images */}
            <div className="section-gallery">
              <div className="main-image">
                <img 
                  src={sectionData.images[activeImage]} 
                  alt={sectionData.name} 
                />
              </div>
              <div className="image-thumbnails">
                {sectionData.images.map((img, index) => (
                  <button 
                    key={index} 
                    className={`thumbnail-btn ${activeImage === index ? 'active' : ''}`}
                    onClick={() => setActiveImage(index)}
                  >
                    <img src={img} alt={`${sectionData.name} ${index + 1}`} />
                  </button>
                ))}
              </div>
            </div>

            {/* Right Column - Details */}
            <div className="section-details">
              <div className="detail-section">
                <h2>About {sectionData.name}</h2>
                <p className="section-description">{sectionData.longDescription}</p>
              </div>

              <div className="coach-info">
                <div className="info-card">
                  <i className="fas fa-user-tie"></i>
                  <div>
                    <h4>Instructors</h4>
                    <p>{sectionData.coach}</p>
                  </div>
                </div>
                <div className="info-card">
                  <i className="fas fa-users"></i>
                  <div>
                    <h4>Members</h4>
                    <p>{sectionData.members}</p>
                  </div>
                </div>
                <div className="info-card">
                  <i className="fas fa-clock"></i>
                  <div>
                    <h4>Schedule</h4>
                    <p>{sectionData.schedule}</p>
                  </div>
                </div>
              </div>

              <div className="detail-section">
                <h3>Key Features</h3>
                <ul className="features-list">
                  {sectionData.features.map((feature, index) => (
                    <li key={index}>
                      <i className="fas fa-check-circle"></i>
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="additional-info">
                <div className="info-row">
                  <span className="info-label">Classes:</span>
                  <span className="info-value">{sectionData.classes.join(' • ')}</span>
                </div>
                <div className="info-row">
                  <span className="info-label">Performances:</span>
                  <span className="info-value">{sectionData.performances.join(' • ')}</span>
                </div>
              </div>

              <div className="action-buttons">
                <Link to="/login" className="btn btn-primary btn-large">
                  <i className="fas fa-handshake"></i> Join This Section
                </Link>
                <Link to="/contact" className="btn btn-outline btn-large">
                  <i className="fas fa-calendar"></i> Trial Class
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BalletGymnastics;